import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

interface Shipment {
	Id: string;
	Name: string;
	Freight_Mode__c: string;
	Service_type__c: string;
	Status_Stage_1__c?: string;
	Status_Stage_2__c?: string;
	Account_Shipment_Reference__c?: string;
	from?: string | null;
	to?: string | null;
}

interface LatestShipmentWithTracking {
	Id: string;
	Name: string;
	from?: string | null;
	to?: string | null;
	tracking_info?: {
		data?: any;
	};
}

interface TopPerformersState {
	shipments: Shipment[];
	latestShipmentWithTrackingInfo: LatestShipmentWithTracking | null;
	loading: boolean;
	error: string | null;
	selectedYear: string;
	lastUpdated: number | null;
}

const initialState: TopPerformersState = {
	shipments: [],
	latestShipmentWithTrackingInfo: null,
	loading: false,
	error: null,
	selectedYear: new Date().getFullYear().toString(),
	lastUpdated: null,
};

export const topPerformersSlice = createSlice({
	name: "topPerformers",
	initialState,
	reducers: {
		setShipments: (state, action: PayloadAction<Shipment[]>) => {
			state.shipments = action.payload;
			state.loading = false;
			state.error = null;
			state.lastUpdated = Date.now();
		},
		setLatestShipmentWithTrackingInfo: (
			state,
			action: PayloadAction<LatestShipmentWithTracking | null>,
		) => {
			state.latestShipmentWithTrackingInfo = action.payload;
			state.loading = false;
			state.error = null;
			state.lastUpdated = Date.now();
		},
		setLatestShipments: (
			state,
			action: PayloadAction<{
				shipments: Shipment[];
				latest_shipment_with_tracking_info: LatestShipmentWithTracking | null;
			}>,
		) => {
			state.shipments = action.payload.shipments;
			state.latestShipmentWithTrackingInfo =
				action.payload.latest_shipment_with_tracking_info;
			state.loading = false;
			state.error = null;
			state.lastUpdated = Date.now();
		},
		setLoading: (state, action: PayloadAction<boolean>) => {
			state.loading = action.payload;
			if (action.payload) {
				state.error = null;
			}
		},
		setError: (state, action: PayloadAction<string>) => {
			state.error = action.payload;
			state.loading = false;
		},
		setSelectedYear: (state, action: PayloadAction<string>) => {
			state.selectedYear = action.payload;
		},
		clearLatestShipments: (state) => {
			state.shipments = [];
			state.latestShipmentWithTrackingInfo = null;
			state.loading = false;
			state.error = null;
			state.lastUpdated = null;
		},
	},
});

export const {
	setShipments,
	setLatestShipmentWithTrackingInfo,
	setLatestShipments,
	setLoading,
	setError,
	setSelectedYear,
	clearLatestShipments,
} = topPerformersSlice.actions;

export default topPerformersSlice.reducer;
